module.exports = __webpack_public_path__ + "media/img/logo-transparent-sm-dark-bare-b98a99e38ae369d052030b67874a6d72.png";